import { loadStripe, type Stripe } from "@stripe/stripe-js";

const publishableKey = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;

let stripePromise: Promise<Stripe | null> | null = null;

/**
 * Lazily-initialized Stripe.js singleton for Stripe Elements. Returns null
 * when no publishable key is configured so callers can degrade gracefully
 * (e.g. fall back to the hosted pay link).
 */
export function getStripe(): Promise<Stripe | null> {
    if (!publishableKey) return Promise.resolve(null);
    if (!stripePromise) stripePromise = loadStripe(publishableKey);
    return stripePromise;
}

export function isStripeConfigured(): boolean {
    return !!publishableKey;
}
